<div
    class="p-2 grid grid-cols-5 gap-5 items-end rounded-xl transition-colors"
    [ngClass]="{
        'bg-error bg-opacity-30': markedAsDeleted
    }"
    [formGroup]="selectionDescriptionForm"
>
    <div class="form-control transition-opacity" [ngClass]="{ 'opacity-50': markedAsDeleted }">
        <label class="label pb-0">
            <span class="label-text" i18n>Unique key</span>
        </label>
        <input type="text" class="input input-bordered w-full" formControlName="selectionKey" />
    </div>
    <div class="form-control transition-opacity" [ngClass]="{ 'opacity-50': markedAsDeleted }">
        <label class="label pb-0">
            <span class="label-text" i18n>Name</span>
        </label>
        <input type="text" class="input input-bordered w-full" formControlName="name" />
    </div>
    <div class="col-span-2 form-control transition-opacity" [ngClass]="{ 'opacity-50': markedAsDeleted }">
        <label class="label pb-0">
            <span class="label-text" i18n>Comment</span>
        </label>
        <input type="text" class="input input-bordered w-full" formControlName="comment" />
    </div>
    <div class="flex flex-row justify-end items-center gap-2">
        <button *ngIf="!editMode && !markedAsDeleted" (click)="edit()">
            <iota-icon icon="pencil-square" class="text-primary" size="1.2"></iota-icon>
        </button>
        <button
            class="btn btn-primary"
            *ngIf="editMode && !markedAsDeleted"
            [disabled]="!selectionDescriptionForm.valid"
            (click)="saveEdit()"
        >
            <iota-icon icon="check" size="1.2"></iota-icon>
        </button>
        <button class="btn btn-error" *ngIf="!markedAsDeleted" (click)="markAsDeleted()">
            <iota-icon icon="trash" size="1.2"></iota-icon>
        </button>
        <button class="btn btn-secondary" *ngIf="markedAsDeleted" (click)="undoDelete()">
            <iota-icon icon="arrow-path" size="1.2"></iota-icon>
        </button>
    </div>
</div>
